export const NormalizarNomeCidade = (nome: string): string => {
    if (!nome) return "";

    let resultado = nome.trim();

    // 1. Remove acentos (converte caracteres acentuados para seus equivalentes sem acento)
    resultado = resultado.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

    // 2. Remove caracteres especiais (mantém apenas letras, números e espaços)
    resultado = resultado.replace(/[^a-zA-Z0-9\s]/g, " ");

    // 3. Remove espaços extras e converte para maiúsculo
    resultado = resultado.trim().replace(/\s+/g, " ").toUpperCase();

    return resultado;
};